import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import HighchartsVue from 'highcharts-vue';
import 'sweetalert2/dist/sweetalert2.min.css';
import Paginate from 'vuejs-paginate';

import VueResource from 'vue-resource';
import App from './App.vue';
import router from './router';
import store from './store';
import './themes/default/style.scss';

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(HighchartsVue);
Vue.component('paginate', Paginate);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
